
const Index = () => import(/* webpackChunkName: "report" */ './index.vue');

import customerRoutes from '@/modules/ReportView/components/customer/router'
import studentRouters from '@/modules/ReportView/components/student/router'
import attendanceRouters from '@/modules/ReportView/components/attendance/router'
import profitRoutes from '@/modules/ReportView/components/profitAndLost/router'
import invoiceRoutes from '@/modules/ReportView/components/invoice/router'
import departmentsRoutes from '@/modules/ReportView/components/departments/router'
import saleRoutes from '@/modules/ReportView/components/sale/router'
import productRoutes from '@/modules/ReportView/components/product/router'
import expenseRoutes from '@/modules/ReportView/components/expense/router'
import paymentRoutes from '@/modules/ReportView/components/payment/router'
import inventoryRoutes from '@/modules/ReportView/components/inventory/router'
import transactionRoutes from '@/modules/ReportView/components/transaction/router.js'


let childrenRoutes = []

childrenRoutes = childrenRoutes.concat(customerRoutes)
childrenRoutes = childrenRoutes.concat(studentRouters)
childrenRoutes = childrenRoutes.concat(invoiceRoutes)
childrenRoutes = childrenRoutes.concat(departmentsRoutes)
childrenRoutes = childrenRoutes.concat(profitRoutes)
childrenRoutes = childrenRoutes.concat(saleRoutes)
childrenRoutes = childrenRoutes.concat(expenseRoutes)
childrenRoutes = childrenRoutes.concat(paymentRoutes)
childrenRoutes = childrenRoutes.concat(productRoutes)
childrenRoutes = childrenRoutes.concat(inventoryRoutes)
childrenRoutes = childrenRoutes.concat(attendanceRouters)
childrenRoutes = childrenRoutes.concat(transactionRoutes)



export default [{
  path: '/reportView',
  name: 'report-view',
  component: Index,
  children: childrenRoutes
}, ]